import { useState } from 'react';
import type { AresContact } from '../api/types';
import { AresLookup } from '../components/AresLookup';
import { Btn, Hint } from '../components/ui';

/** Sheet „Načíst z ARES“: tenký obal nad AresLookup pro toky, kde se IČO zadává samostatně. */
export function AresSheet({
  onFound,
  onCancel,
}: {
  onFound: (c: AresContact) => void;
  onCancel: () => void;
}) {
  const [ico, setIco] = useState('');

  return (
    <>
      <h3>Načíst z ARES</h3>
      <p className="muted mb">Zadej IČO, zbytek doplníme z registru.</p>
      <AresLookup value={ico} onChange={setIco} onFound={onFound} />
      <Btn full onClick={onCancel}>
        Zrušit
      </Btn>
      <Hint>
        Ostrá data z ARES REST API (ares.gov.cz). Název, sídlo a DIČ se doplní do kontaktu.
      </Hint>
    </>
  );
}
